import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'ascension-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Ascension Saint Thomas Urgent Care',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-933-7030,
  email: 'support@asturgentcare.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/ascension/index.js